import Vue from 'vue'
import Router from 'vue-router'
const Login = () =>import("../components/Login")
const LexueContainer = () =>import("../components/LexueContainer")

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/login' },
    {
      path: '/sys',
      name: 'LexueContainer',
      component: LexueContainer,
      hidden: true,
      meta: { requireAuth: false },
      children: [
        { path: '/login', name: 'Login', component: Login, hidden: true }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/sso/router/index.js